import * as React from 'react';
import { ExcursionIcon } from './components/ExcursionIcon';
import { ExcursionModal } from './components/ExcursionModal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function ExcursionBlock(_ref) {
  let {
    tourUrl,
    onOpen
  } = _ref;
  const [open, setOpen] = React.useState(false);
  if (!tourUrl) {
    return null;
  }
  const handleClick = () => {
    if (!open) {
      onOpen();
    }
    setOpen(!open);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ExcursionIcon, {
      onClick: handleClick
    }), open && /*#__PURE__*/_jsx(ExcursionModal, {
      tourUrl: tourUrl,
      onClose: handleClick
    })]
  });
}